import React from 'react';
import { JsonLd } from "react-schemaorg";
export default function BreadcrumbListSchema(firstUrl, firstTitle, secondUrl, secondTitle) {
    return (React.createElement(JsonLd, { item: {
            "@context": "https://schema.org",
            '@type': 'BreadcrumbList',
            itemListElement: [
                {
                    "@type": "ListItem",
                    position: 1,
                    item: {
                        "@id": firstUrl,
                        name: firstTitle
                    }
                },
                {
                    "@type": "ListItem",
                    position: 2,
                    item: {
                        "@id": secondUrl,
                        name: secondTitle
                    }
                }
            ]
        } }));
}
